<template>
  <div v-if="Object.keys(inquiry.request).length !== 0" class="section">
    <div class="inquiry-wrap">
      <div class="section-tit">1:1 문의상세</div>
      <div class="inquiry-product" v-if="!isEmpty(inquiry.product?.goodsList.length > 0)">
        <img
          class="product-image"
          :src="inquiry.product?.goodsList[0]?.main_image_url"
          alt="상품 이미지"
        />
        <div class="product-details">
          <div class="product-title">
            [{{ inquiry.product?.goodsList[0]?.brand }}]
            {{ inquiry.product?.goodsList[0]?.product_name }}
          </div>
          <div class="product-price">
            <!-- 정가
            <span class="font-strike"
              >{{ _formatAmount(inquiry.product.goodsList[0]?.cost_price) }}원</span
            >&nbsp;&nbsp;|&nbsp;&nbsp; -->
            구매가
            <span class="font-blue">{{ _formatAmount(inquiry.sellingPrice) }}원</span>
          </div>
        </div>
      </div>
      <div class="inquiry-detail">
        <div class="inquiry-list">
          <div class="inquiry-item" style="cursor: default">
            <div class="inquiry-title">{{ inquiry.request.title }}</div>
            <div class="inquiry-date">{{ inquiry.request.u_datetime?.split(' ')[0] }}</div>
            <div
              class="inquiry-status"
              :class="{
                waiting: inquiry.request.status === 2,
                done: inquiry.request.status != 2,
              }"
            >
              {{ inquiry.request.status == 2 ? '답변 대기중' : '답변 완료' }}
            </div>
          </div>
        </div>
        <div class="inquiry-content">
          <div class="label">문의 내용</div>
          <div class="content">{{ inquiry.request.inquiry_contents }}</div>
          <div class="label">첨부한 사진 ({{ inquiry.imgages.length }})</div>
          <div class="images">
            <img
              v-for="(img, idx) in inquiry.imgages"
              :key="idx"
              :src="img"
              alt="첨부 이미지"
              @click="showImage(img)"
            />
          </div>
          <template v-if="inquiry.answer.length !== 0">
            <div class="label">답변</div>

            <div v-for="(ans, idx) in inquiry.answer" :key="idx">
              <div class="answer">
                <p>{{ ans.answer_contents }}</p>
                <div class="images">
                  <div
                    v-for="(img, idx) in [ans.img_url_1, ans.img_url_2, ans.img_url_3]"
                    :key="idx"
                  >
                    <img
                      v-if="img"
                      :key="idx"
                      :src="img"
                      alt="첨부 이미지"
                      @click="showImage(img)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="inquiry.request.status == 2" class="btn-wrap">
        <button class="btn btn-lg btn-full btn-primary" @click="editInquiry()">수정하기</button>
      </div>

      <div v-if="showModal" class="modal" @click="closeModal">
        <img :src="selectedImage" alt="확대 이미지" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { _formatAmount, _getStorageWithExpiry, _safeAtob } from '../utils/common.js';
import api from '@/utils/api.js';
import Footer from '@/components/Footer.vue';
import { isEmpty } from 'lodash';

const idx = JSON.parse(history.state.idx);
const router = useRouter();
const idntCode = _safeAtob(_getStorageWithExpiry('id'));

const inquiry = reactive({
  request: {},
  answer: [],
  product: { goodsList: [] },
  images: [],
  sellingPrice: 0,
});
const showModal = ref(false);
const selectedImage = ref('');

function showImage(i) {
  selectedImage.value = i;
  showModal.value = true;
}
function closeModal() {
  showModal.value = false;
}

onMounted(() => {
  fetchData();
});

async function fetchData() {
  try {
    const response = await api.post('/order.php', {
      mode: 'requestAnswer',
      idx: idx,
      type: 99,
      idnt_code: idntCode,
    });

    const { request, answer: rawAnswer, marketOrderList } = response.data.data;

    inquiry.answer = Array.isArray(rawAnswer)
      ? rawAnswer.filter(item => item !== null && item !== undefined && item !== '')
      : [];

    inquiry.request = request;
    inquiry.product = marketOrderList;

    inquiry.imgages = [
      inquiry.request.img_url_1,
      inquiry.request.img_url_2,
      inquiry.request.img_url_3,
    ].filter(url => url);

    const response2 = await api.post('/tble.php', {
      mode: 'orderPrice',
      market_order_id: request.market_order_id,
      goods_code: inquiry.product.goodsList[0].goods_code,
      idnt_code: idntCode,
    });
    inquiry.sellingPrice = response2.data.data.selling_price;
  } catch (error) {
    console.error('에러 발생:', error);
  }
}

function editInquiry() {
  router.push({
    path: '/inquiry',
    state: {
      idx: idx,
      request: JSON.stringify(inquiry.request),
      goodsCode: inquiry.product?.goodsList?.[0]?.goods_code || '',
    },
  });
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
}
</style>
